module.exports = __webpack_public_path__ + "static/img/merchant_detail_banner.59070cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_detail_banner.png
// module id = Ouje
// module chunks = 8